import React, { useEffect, useState } from 'react'
import InputField from '../../../components/ui/Input'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const quillModules = {
    toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'align': [] }],
        ['link'],
        ['clean']
    ],
};

const quillFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'indent',
    'align',
    'link'
];

const CreateAppSettingModal = ({ onCancel, onSubmit, title, inputData, handleONChange, error }) => {
    const [appValue, setAppValue] = useState(inputData?.value);
    useEffect(() => {
        handleONChange({ target: { name: "value", value: appValue } })
    }, [appValue]);


    const numberKey = ['PlateForm_fee',]

    const textKey = [
        '3. Can I request a refund for a course? ', 
        '2. How can I report inappropriate content or behaviour? ', 
        '1. Does Telgros have a community space? ',
        '3. What happens if I experience technical issues? ',
        '2. What payment methods does Telgros support? ',
        '1. Is my personal data safe on Telgros? ',
        '7. How do I increase my visibility on Telgros? ',
        '6. How do I interact with students? ',
        '5. What kind of content can I upload? ',
        '4. Can I offer free content? ',
        '3. How do I get paid for my courses or sessions? ',
        '2. Can I set my own prices for courses? ',
        '1. How do I become an educator on Telgros? ',
        '7. Can I leave reviews for educators? ',
        '6. Can I ask questions if I do not understand something? ',
        '5. How do I pay for a course or live session? ',
        '4. Are all courses free? ',
        '3. Can I schedule live lessons with an educator?',
        '2. How do I find a course or an educator? ',
        '1. How do I sign up as a learner? ',
        '4. Is Telgros available on mobile? ',
        '3. Who can use Telgros? ',
        '2. How does Telgros work? ',
        '1. What is Telgros? ',

    ]

    const styleKey = ['certificate', 'certificate1', 'TermAndCondition', 'about_us', 'privacy_policy', 'website123.com']

    return (
        <div>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 bg-opacity-60 backdrop-blur-sm">
                <div className="bg-white rounded-lg shadow-xl w-11/12 md:w-[50rem]">
                    <div className="border-b">
                        <div className="flex items-center justify-between p-6 pb-4 border-b">
                            <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
                            <button
                                className="w-10 h-10 text-2xl text-gray-500 transition-colors bg-gray-100 rounded-full hover:text-gray-800"
                                onClick={onCancel}
                            >
                                &times;
                            </button>
                        </div>
                    </div>
                    <div className="p-6 space-y-6">
                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                            <div>
                                <InputField
                                    label="Name"
                                    isDisable={title !== "Create App Setting"}
                                    name="name"
                                    value={inputData?.name}
                                    onChange={handleONChange}
                                    className="transition duration-300"
                                />
                                {error?.name && <p className="text-sm text-red-500">{error?.name}</p>}
                            </div>
                            <div>
                                <InputField
                                    label="Key"
                                    name="key"
                                    isDisable={title !== "Create App Setting"}
                                    value={inputData?.key}
                                    onChange={handleONChange}
                                    className="transition duration-300"
                                />
                                {error?.key && <p className="text-sm text-red-500">{error?.key}</p>}
                            </div>
                        </div>

                        <div className="space-y-4">
                            {/* <button
                                type="button"
                                className={`px-5 py-2 rounded-md ${isEditor ? "bg-blue-600 text-white" : "bg-gray-300 text-black"} 
                        hover:${isEditor ? "bg-blue-700" : "bg-gray-400"} transition duration-300`}
                                onClick={() => setIsEditor(!isEditor)}
                            >
                                {isEditor ? "Use Plain Text" : "Editor"}
                            </button> */}

                            {numberKey?.includes(inputData.key) ? (
                                <InputField
                                    label="Value"
                                    name="value"
                                    type="number"
                                    value={inputData?.value}
                                    onChange={handleONChange}
                                    className="transition duration-300"
                                />
                            ) : textKey?.includes(inputData.key) ? (
                                <InputField
                                    label="Value"
                                    name="value"
                                    type="textarea"
                                    value={inputData?.value}
                                    onChange={handleONChange}
                                    className="transition duration-300"
                                />
                            ) : (
                                <ReactQuill
                                    theme="snow"
                                    value={inputData?.value}
                                    onChange={setAppValue}
                                    modules={quillModules}
                                    formats={quillFormats}
                                    style={{ height: '300px', overflowY: 'auto' }}
                                />
                            )}
                            {error?.value && <p className="text-sm text-red-500">{error?.value}</p>}
                        </div>
                    </div>

                    <div className="flex justify-end p-6 space-x-4 border-t">
                        <button
                            className="px-6 py-2 text-gray-700 transition duration-300 bg-gray-100 rounded-md hover:bg-gray-200"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            className="px-6 py-2 text-white transition duration-300 bg-purple-600 rounded-md hover:bg-purple-700"
                            onClick={onSubmit}
                        >
                            {title === 'Update App Settings' ? "Update" : "Create"}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        // <div>
        //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 bg-black/50 backdrop-blur-sm">
        //         <div className="bg-white rounded-lg shadow-lg w-[50rem]">
        //             <div className='w-full border-b'>
        //                 <div className="flex items-center justify-between p-6 pb-2 border-b">
        //                     <h3 className="text-lg font-semibold">{title}</h3>
        //                     <button
        //                         className="w-10 h-10 text-2xl text-gray-500 bg-gray-100 rounded-full hover:text-gray-800"
        //                         onClick={onCancel}
        //                     >
        //                         &times;
        //                     </button>
        //                 </div>
        //             </div>
        //             <div className='p-4 '>
        //                 <div className='grid items-center grid-cols-2 gap-4'>
        //                     <div>
        //                         <InputField label={`Name`} isDisable={title !=="Create App Setting"} name='name' value={inputData?.name} onChange={handleONChange} />
        //                         {error?.name && <p className="text-sm text-red-500">{error?.name}</p>}
        //                     </div>
        //                     <div>
        //                         <InputField label={`key`} name='key' isDisable={title !=="Create App Setting"} value={inputData?.key} onChange={handleONChange} />
        //                         {error?.key && <p className="text-sm text-red-500">{error?.key}</p>}
        //                     </div>
        //                 </div>
        //                 <button type='button' className={`px-4 py-2 rounded ${isEditor ? "bg-blue-500 text-white" : "bg-gray-300 text-black"
        //                     }`}
        //                     onClick={() => setIsEditor(!isEditor)} >Editor</button>
        //                 {!isEditor ? <InputField label={`Value`} name='value' value={inputData?.value} onChange={handleONChange} /> :
        //                     <ReactQuill
        //                         theme="snow"
        //                         value={inputData?.value}
        //                         onChange={setAppValue}
        //                         modules={quillModules}
        //                         formats={quillFormats}
        //                         style={{ height: '300px', overflowY: 'auto' }}
        //                     />}
        //                 {error?.value && <p className="text-sm text-red-500">{error?.value}</p>}
        //             </div>


        //             <div className="flex justify-end p-4 mt-6 space-x-3 border-t">
        //                 <button
        //                     className="px-6 py-2 border border-[#B8B8D2] text-gray-700 rounded hover:bg-gray-300"
        //                     onClick={onCancel}
        //                 >
        //                     Cancel
        //                 </button>
        //                 <button
        //                     className="px-6 py-2 text-white bg-purple-600 rounded hover:bg-purple-700"
        //                     onClick={onSubmit}
        //                 >
        //                     {title === 'Update App Settings' ? "Update" : "Create"}
        //                 </button>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default CreateAppSettingModal
